import { pageContext } from 'ctm-util-functions';

import { all, takeEvery, takeLatest } from 'redux-saga/effects';
import * as sagas from '.';

const trackingSagas = [
    // track set results quotes for the journey.
    takeLatest('SET_RESULTS_PAYLOAD', sagas.track),
    takeLatest('SET_RESULTS_PAYLOAD_HNC', sagas.track),
    // track unavailable quotes
    takeLatest('TRACK_UNAVAILABLE_QUOTES', sagas.track),
    // track user sorts the results.
    takeLatest('SORT_RESULTS', sagas.track),
    // track multilevel sorting of results.
    takeLatest('SORT_ARRAY_MULTI_LEVEL', sagas.track),
    // track when only unstaged filters changed
    takeLatest('SET_FILTER_VALUE', sagas.track),
    takeLatest('REMOVE_FILTER_ARRAY', sagas.track),
    takeLatest('SET_FILTER_ARRAY', sagas.track),
    // Track comparison
    takeLatest('TOGGLE_COMPARE_MODE', sagas.track),
    // toggling display mode - price to features
    takeLatest('SET_RESULTS_CONFIG_VALUE', sagas.track),
    // track initial form.
    takeLatest('TRACK_INITIAL_FORM', sagas.track),
    // track visited journey page.
    takeLatest('SET_ROUTER_LOCATION', sagas.track),
    // track transaction updated.
    takeLatest('SET_JOURNEY_PAYLOAD', sagas.track),
    // track offerDetails
    takeLatest('SET_OFFER_DETAILS', sagas.track),
    takeLatest('OFFER_SHOWN', sagas.track),
    takeLatest('ELEVEN_MONTH_QUOTE_START', sagas.track),
    takeLatest('ELEVEN_MONTH_RESULTS', sagas.track),
    takeLatest('ELEVEN_MONTH_VERIFY', sagas.track),
    // track anon prefill
    takeLatest('PREFILL_VERIFY_FAIL', sagas.track),
    takeLatest('PREFILL_LOCKOUT', sagas.track),
    takeLatest('PREFILL_QUOTE_START', sagas.track),
    takeLatest('PREFILL_CHECK_SUCCESS', sagas.track),
    takeLatest('PREFILL_CHECK_FAILED', sagas.track),
    takeLatest('PREFILL_SAVED_RESULTS', sagas.track),
    takeLatest('PREFILL_WELCOME_BACK', sagas.track),
    takeLatest('TRACK_LOADING_PAGE', sagas.track),
    takeEvery('TRACK_LOADING_PAGE_API_RESULT', sagas.track),
    // track errorTracking (first 5 validation errors).
    takeLatest('VALIDATE_PAGE', sagas.track),
    // track product view.
    takeLatest('MORE_INFO_OPEN', sagas.track),
    // track product hand over click.
    takeLatest('ONLINE_HANDOVER', sagas.track),
    takeLatest('CALL_DIRECT', sagas.track),
    takeLatest('TRACK_CALL_ME_BACK', sagas.track),
    // track no results.
    takeLatest('NO_RESULTS', sagas.track),
    // track location not supported.
    takeLatest('POSTCODE_NOT_SUPPORTED', sagas.track),
    // track quote transfer
    takeLatest('HANDOVER_TO_PARTNER', sagas.track),
    // track msats data retrieval status
    takeLatest('TRACK_MSATS_RETRIEVAL_STATUS', sagas.track)
];

const payloadSagas = [
    takeEvery('POST_PAYLOAD', sagas.processPayloadAction),
    takeEvery('GET_PAYLOAD', sagas.processPayloadAction),
    takeLatest('REQUEST_PROVIDERS', sagas.processPayloadIfTransactionAction),
    takeLatest('GET_SUBURBS_FROM_POSTCODE', sagas.processPayloadAction),
    takeLatest('POST_PAYLOAD_ADDRESS', sagas.processPayloadAction),
    takeLatest('MORE_INFO', sagas.processPayloadAction),
    takeLatest('CALL_DIRECT', sagas.processPayloadAction),
    takeLatest('CALL_ME_BACK', sagas.processPayloadAction),
    takeLatest('ONLINE_HANDOVER', sagas.processPayloadAction),
    takeLatest('SEQUENTIAL_API_CALLS', sagas.processPayloadActions)
];

const preloadSagas = [
    takeLatest('PRELOAD_FORM_ELEMENTS_API_VALUES', sagas.processPreloadFormElementsApiValues)
];

const journeySagas = [
    takeLatest('LOAD_PAGE_DATA', sagas.loadPageData),
    takeLatest('GET_NEW_JOURNEY_PAYLOAD', sagas.processNewJourneyAction),
    takeLatest('GET_LOAD_JOURNEY_PAYLOAD', sagas.processLoadJourneyAction),
    takeEvery('SET_LOGGING_IDENTIFY', sagas.errorLogging),
    takeEvery('SET_FORM_VALUE', sagas.setFormValue),
    takeEvery('VALIDATE_AND_PROGRESS', sagas.validateAndProgress),
    takeEvery('VALIDATE_AND_SUBMIT', sagas.validateAndSubmit),
    takeLatest('PROGRESS_TO_PAGE', sagas.progressToPage),
    takeLatest('SAVE_MARKETING', sagas.saveMarketing),
    takeLatest('CANCEL_STAGED_FILTERS', sagas.cancelStagedFilters),
    takeLatest('ACTIVATE_STAGED_FILTERS', sagas.applyStagedFilters),
    takeLatest('DO_PREFILL_VERIFY', sagas.processPrefillVerifyAction),
    takeLatest('PROCESS_PROACTIVE_HANDOVER', sagas.processProactiveHandover),
    takeLatest('PREFILL_DONE', sagas.postPrefillAction)
];

const verticalSpecificSagas = pageContext.getProps().verticalSagas.map(
    ([action, saga]) => takeLatest(action, saga),
);

/**
 * The collection of sagas for api calls
 * Spawns a saga on each action dispatched to the Store that matches pattern.
 */
export const rootSaga = function* () {
    yield all([
        ...preloadSagas,
        ...journeySagas,
        ...payloadSagas,
        ...trackingSagas,
        ...verticalSpecificSagas
    ]);
};
